export type TPaywallFeature =
  | 'PAYWALL_FEATURE_UNSPECIFIED'
  | 'PAYWALL_FEATURE_KEYSTATS'
  | 'PAYWALL_FEATURE_ANALYSIS'
  | 'PAYWALL_FEATURE_FINANCIALS'
  | 'PAYWALL_FEATURE_FUNDACHART'
  | 'PAYWALL_FEATURE_SEASONALITY'
  | 'PAYWALL_FEATURE_CHARTBIT'
  | 'PAYWALL_FEATURE_COMPARISON'
  | 'PAYWALL_FEATURE_INSIDER'
  | 'PAYWALL_FEATURE_COMPANY_PROFILE'
  | 'PAYWALL_FEATURE_CORP_ACTION'
  | 'PAYWALL_FEATURE_PRICE_ALERT'
  | 'PAYWALL_FEATURE_RUNNING_TRADE'
  | 'PAYWALL_FEATURE_VALUATION'
  | 'PAYWALL_FEATURE_BANDAR_DETECTOR'
  | 'PAYWALL_FEATURE_ORDERBOOK'
  | 'PAYWALL_FEATURE_SCREENER'
  | 'PAYWALL_FEATURE_CALENDAR'
  | 'PAYWALL_FEATURE_EARNINGS'

export type TSubscriptions =
  | 'SUBSCRIPTION_UNSPECIFIED'
  | 'SUBSCRIPTION_ONE_DAY'
  | 'SUBSCRIPTION_ONE_MONTH'
  | 'SUBSCRIPTION_SIX_MONTHS'
  | 'SUBSCRIPTION_ONE_YEAR'

export enum SectionEnum {
  page = 'page',
  company = 'company',
  widget = 'widget',
}

export type TSectionType = keyof typeof SectionEnum;

export interface IFeatureData {
  feature: TPaywallFeature;
  is_eligible: boolean;
}

export interface ICompanyData {
  company: string;
  is_eligible: boolean;
}

export interface ISubscriptionData {
  id: number;
  subscription: TSubscriptions;
}

export interface IPaywallData {
  features: IFeatureData[];
  company: ICompanyData | null;
  last_subscription: ISubscriptionData | null;
}

export interface IPaywallPayload {
  key: TSectionType;
  feature: TPaywallFeature;
  company?: string;
}

export interface IMultiplePayload {
  key: TSectionType;
  feature: Array<TPaywallFeature>;
  company?: string;
  addOnKey?: TSectionType;
}

export interface ICounterPayload {
  feature: TPaywallFeature;
  company?: string;
}

export interface ISectionData {
  isLoading: boolean;
  isRenewal: boolean;
  isPro: boolean;
  data: IPaywallData;
}

export type TPaywallState = {
  [key in TSectionType]: ISectionData;
};

export interface IPaywallAction {
  getStatus: (payload: IPaywallPayload | IMultiplePayload) => Promise<IPaywallData>;
  addCounter: (payload: ICounterPayload) => Promise<void>;
  resetProStatus: (key: TSectionType) => void;
}
